import React from "react";
import { Delete } from "lucide-react";

const ROWS = [
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
  ["ENTER", "Z", "X", "C", "V", "B", "N", "M", "BACK"],
];

/**
 * Props:
 *  - onKey(k: string)
 *  - letterStates: { A: "correct" | "present" | "absent", ... }
 *  - disabled: bool
 */
export default function Keyboard({ onKey, letterStates = {}, disabled }) {
  const handle = (k) => {
    if (disabled) return;
    onKey(k);
  };
  return (
    <div className="w-full max-w-2xl mx-auto flex flex-col gap-2 select-none" data-testid="on-screen-keyboard">
      {ROWS.map((row, i) => (
        <div key={i} className="flex justify-center gap-1.5">
          {row.map((k) => {
            const state = letterStates[k] || "";
            const wide = k === "ENTER" || k === "BACK";
            return (
              <button
                key={k}
                onClick={() => handle(k)}
                disabled={disabled}
                className={`kbd-key ${wide ? "wide" : ""} ${state}`}
                data-testid={`key-${k}`}
              >
                {k === "BACK" ? <Delete size={18} /> : k}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
